import { ApolloClient, ApolloLink, createHttpLink } from '@apollo/client';
import { InMemoryCache } from '@apollo/client/cache';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

import { COGNITO_KEYS as CONTROLLER_COGNITO_KEYS } from '../constants';
import {
  COGNITO_KEYS,
  COGNITO_ENV_ADMIN,
  COGNITO_ENV_PORTAL,
  COGNITO_CLIENT_ID_HEADER,
} from '../constants/cognito';
import { getAuthenticationHeader } from '../utils/general';

const errorLink = onError(({ networkError, graphQLErrors }) => {
  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
  }

  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}.`)
    );
  }
});

const devicesLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_DEVICE,
});

const newDevicesLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_NEW_DEVICE,
});

const facilityLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_FACILITY,
});

const marketplaceLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_MARKETPLACE,
});

const userLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_USER,
});

const filesLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_FILE,
});

const flowLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_FLOW,
});

const iotLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_IOT,
});

const goCheckItLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_GOCHECKIT,
});

const authLink = setContext(async (GraphQLRequest, { headers }) => {
  const accessHeader = getAuthenticationHeader();
  const adminClientId = localStorage.getItem(COGNITO_KEYS(COGNITO_ENV_ADMIN).CLIENT_ID);
  const portalClientId = localStorage.getItem(COGNITO_KEYS(COGNITO_ENV_PORTAL).CLIENT_ID);
  const controllerClientId = localStorage.getItem(CONTROLLER_COGNITO_KEYS.CLIENT_ID);

  const usedClientId = adminClientId || portalClientId || controllerClientId;
  const clientHeader = usedClientId ? { [COGNITO_CLIENT_ID_HEADER]: usedClientId } : {};

  return {
    headers: {
      ...headers,
      ...(accessHeader ? accessHeader : {}),
      ...clientHeader,
    },
  };
});

export const getApolloClient = (clientUrl, fetchOptions = {}) => {
  return new ApolloClient({
    link: clientUrl,
    fetchOptions,
    cache: new InMemoryCache(),
  });
};

const linkAuth = (clientUrl) => ApolloLink.from([errorLink, authLink.concat(clientUrl)]);

const fetchOptions = {
  mode: 'no-cors',
};

export const devicesClient = getApolloClient(linkAuth(devicesLink));
export const newDeviceClient = getApolloClient(linkAuth(newDevicesLink));
export const facilityClient = getApolloClient(facilityLink, fetchOptions);
export const marketplaceClient = getApolloClient(linkAuth(marketplaceLink));
export const userClient = getApolloClient(userLink, fetchOptions);
export const filesClient = getApolloClient(linkAuth(filesLink));
export const flowClient = getApolloClient(linkAuth(flowLink));
export const iotClient = getApolloClient(linkAuth(iotLink));
export const goCheckItClient = getApolloClient(linkAuth(goCheckItLink));
